"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sms = void 0;
exports.sms = function (axios) {
    return {
        // [SMS]
        getSmsUsagesView: function (getSmsUsagesView) {
            return axios.get('/sms/usages/view', getSmsUsagesView);
        },
        getSmsPublicAppkeyValidation: function (getSmsPublicAppkeyValidationRequest) {
            return axios.get('/sms/public-appkey/validation', getSmsPublicAppkeyValidationRequest);
        },
        getSmsAdBlocker: function (getSmsAdBlockerRequest) {
            return axios.get('/sms/ad-blocker', getSmsAdBlockerRequest);
        },
        // Excelアップロード
        postSmsRecipientExcel: function (postSmsRecipientExcelRequest) {
            return axios.post("/sms/recipient/excel?mallNo=" + postSmsRecipientExcelRequest.params.mallNo, postSmsRecipientExcelRequest.data);
        },
        // メール作成
        postSms: function (postSmsRequest) {
            return axios.post("/sms?mallNo=" + postSmsRequest.params.mallNo, postSmsRequest.data);
        },
        getSmsMessages: function (getSmsMessagesRequest) {
            return axios.get('/sms/messages', getSmsMessagesRequest);
        },
        getSmsOutboundcalleridPublic: function (getSmsOutboundcalleridPublic) {
            return axios.get('/sms/outbound-caller-id/public', getSmsOutboundcalleridPublic);
        },
        getSmsOutboundcaller: function (request) {
            return axios.get('/sms/outbound-caller-id', request);
        },
        postSmsOutboundcaller: function (request) {
            return axios.post("/sms/outbound-caller-id?mallNo=" + request.params.mallNo, request.data);
        },
        getSmsMessagesView: function (getSmsMessagesViewRequest) {
            return axios.get('/sms/messages/view', getSmsMessagesViewRequest);
        },
        getSmsUnsubscribe: function (getSmsUnsubscribeRequest) {
            return axios.get('/sms/unsubscribe', getSmsUnsubscribeRequest);
        },
        getSmsUnsubscribeConfig: function (getSmsUnsubscribeConfigRequest) {
            return axios.get('/sms/unsubscribe/configurations', getSmsUnsubscribeConfigRequest);
        },
        putSmsUnsubscribeConfig: function (putSmsUnsubscribeConfigRequest) {
            return axios.put('/sms/unsubscribe/configurations', putSmsUnsubscribeConfigRequest.data, putSmsUnsubscribeConfigRequest);
        },
        postSmsUnsubscribeSynchronize: function (request) {
            return axios.post("/sms/unsubscribe/synchronize?mallNo=" + request.params.mallNo, request.data);
        },
        getSmsPpublicAppkeyValidation: function (getSmsPpublicAppkeyValidationRequest) {
            return axios.get("/sms/public-appkey/validation?mallNo=" + getSmsPpublicAppkeyValidationRequest.params.mallNo, getSmsPpublicAppkeyValidationRequest);
        }
    };
};
